import { BodyText, theme } from '@kvdbil/components';
import React from 'react';
import { useTranslation } from '~/Locale';
import { MinimumAgeField } from '../../../Fields/shared';
import Link from '~/App/shared/components/Link';
import { getTranslatedDynamicPageRoute } from '~/App/shared/localization/translateRoute';
import { Control, FieldValues, Path } from 'react-hook-form';
import styled from 'styled-components';

const StyledLink = styled(Link)`
  color: ${theme.colors.info.dark} !important;
  font-weight: ${theme.typography.fontBaseBoldWeight};
  position: relative;
`;

interface Props<FormState extends FieldValues> {
  control: Control<FormState>;
  name?: Path<FormState>;
  required?: boolean;
}

export const TermsCheckbox = <FormState extends FieldValues>({
  control,
  name,
  required
}: Props<FormState>) => {
  const { t } = useTranslation();

  return (
    <MinimumAgeField
      data-testid="terms-checkbox"
      name={name}
      control={control}
      required={required}
      t={t}
      color="info"
      label={
        <BodyText as="span">
          {t('I confirm that I am of age and agree to')}{' '}
          <StyledLink
            to={`/${getTranslatedDynamicPageRoute(t, 'aboutKvdTerms')}`}
            noTranslation
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('the terms of Kvdcars')}
          </StyledLink>
          .
        </BodyText>
      }
    />
  );
};
